/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMe } from '../fn/users/get-me';
import { GetMe$Params } from '../fn/users/get-me';
import { getUserGrants } from '../fn/users/get-user-grants';
import { GetUserGrants$Params } from '../fn/users/get-user-grants';
import { Me } from '../models/me';
import { UserGrantsDto } from '../models/user-grants-dto';

@Injectable({ providedIn: 'root' })
export class UsersApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMe()` */
  static readonly GetMePath = '/v0/users/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe$Response(params?: GetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<Me>> {
    return getMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe(params?: GetMe$Params, context?: HttpContext): Observable<Me> {
    return this.getMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<Me>): Me => r.body)
    );
  }

  /** Path part for operation `getUserGrants()` */
  static readonly GetUserGrantsPath = '/v0/users/grants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserGrants$Response(params?: GetUserGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGrantsDto>> {
    return getUserGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserGrants(params?: GetUserGrants$Params, context?: HttpContext): Observable<UserGrantsDto> {
    return this.getUserGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGrantsDto>): UserGrantsDto => r.body)
    );
  }

}
